import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RichTextLinkPropertiesDialogComponent } from '@portal-core/text-editor/components/rich-text-link-properties-dialog/rich-text-link-properties-dialog.component';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';

@NgModule({
  declarations: [
    RichTextLinkPropertiesDialogComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    RichTextLinkPropertiesDialogComponent
  ]
})
export class RichTextLinkPropertiesDialogModule { }
